import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

const { Text } = Typography;

const textAreaCharacterCount = ({ count, maxLength }) => {
  return (
    <Text>
      <small>
        {count}/{maxLength} characters
      </small>
    </Text>
  );
};

textAreaCharacterCount.propTypes = {
  count: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
};

export default textAreaCharacterCount;
